import * as TYPES from "./types";
import db from 'localforage';

export function setCacheValues() {
    return dispatch => {
        dispatch({type: TYPES.REFRESH, refreshing: true});
        db.getItem('IMAGINE_MODE')
            .then(imagineMode => {
                dispatch(setImagineMode(imagineMode));
            })
            .catch(e => {
                console.log(e.message);
            })
            .finally(() => {
                dispatch({type: TYPES.REFRESH, refreshing: false});
            });
    }
}

export function setPassengerTypeWasChanged(passengerTypeWasChanged) {

    return dispatch => {
        dispatch({type: TYPES.REFRESH, refreshing: true});
        dispatch({type: TYPES.SET_PAX_TYPE_WAS_CHANGED, passengerTypeWasChanged: passengerTypeWasChanged});
        dispatch({type: TYPES.REFRESH, refreshing: false});
        return Promise.resolve(passengerTypeWasChanged);
    };
}

export function setImagineMode(imagineMode) {
    return (dispatch, getState) => {
        /*const {flightCourse} = getState();
        const [mainLeg] = flightCourse.legs;
        if (imagineMode) {
            if (mainLeg.origin && mainLeg.origin.airlineOperated) {
                mainLeg.origin = null;
                mainLeg.destination = null;
            }

            if (mainLeg.destination && mainLeg.destination.airlineOperated) {
                mainLeg.destination = null;
            }

            updateCourse(mainLeg);
        }*/
        dispatch({type: TYPES.REFRESH, refreshing: true});
        dispatch({type: TYPES.SET_IMAGINE_MODE, imagineMode: imagineMode});
        db.setItem('IMAGINE_MODE', imagineMode).catch(e => console.log(e.message));
        dispatch({type: TYPES.REFRESH, refreshing: false});
        return Promise.resolve(imagineMode);
    }
}

export function setRoundTrip(roundTrip) {
    return dispatch => {
        dispatch({type: TYPES.REFRESH, refreshing: true});
        dispatch({type: TYPES.SET_ROUND_TRIP, roundTrip: roundTrip});
        dispatch({type: TYPES.REFRESH, refreshing: false});
        return Promise.resolve(roundTrip);
    };
}

export function setPassengers(adults = 1, children = 0, infants = 0) {
    return dispatch => {
        dispatch({type: TYPES.REFRESH, refreshing: true});
        if (infants <= adults && children <= 8 - adults && adults <= 8 - children) {
            dispatch({type: TYPES.SET_PASSENGERS, adults: adults, children: children, infants: infants});
            dispatch({type: TYPES.REFRESH, refreshing: false});
            return Promise.resolve({adults: adults, children: children, infants: infants});
        }

        return Promise.reject('Check the pax condition: Adults <= 8 - Children | Children <= 8 - Adults | Infants <= Adults');
    };
}

export function setPassengerType(type) {
    return dispatch => {
        dispatch({type: TYPES.REFRESH, refreshing: true});
        dispatch({type: TYPES.SET_PASSENGER_TYPE, passengerType: type});
        dispatch({type: TYPES.REFRESH, refreshing: false});
        return Promise.resolve(type);
    };
}

export function setPromoCode(code) {
    return dispatch => {
        dispatch({type: TYPES.REFRESH, refreshing: true});
        dispatch({type: TYPES.SET_PROMO_CODE, promoCode: code});
        dispatch({type: TYPES.REFRESH, refreshing: false});
        return Promise.resolve(code);
    };
}

export function addCourse(course = null) {
    return dispatch => {
        dispatch({type: TYPES.REFRESH, refreshing: true});
        dispatch({type: TYPES.ADD_COURSE, course});
        dispatch({type: TYPES.REFRESH, refreshing: false});
        return Promise.resolve(course);
    };
}

export function removeCourse(course) {
    return dispatch => {
        dispatch({type: TYPES.REFRESH, refreshing: true});
        dispatch({type: TYPES.REMOVE_COURSE, course});
        dispatch({type: TYPES.REFRESH, refreshing: false});
        return Promise.resolve(course);
    };
}

export function updateCourse(course) {
    return dispatch => {
        dispatch({type: TYPES.REFRESH, refreshing: true});
        dispatch({type: TYPES.UPDATE_COURSE, course});
        dispatch({type: TYPES.REFRESH, refreshing: false});
        return Promise.resolve(course);
    };
}

export function switchCoursesIndexes(idxA, idxB) {
    return dispatch => {
        dispatch({type: TYPES.REFRESH, refreshing: true});
        dispatch({type: TYPES.SWITCH_COURSES_INDEXES, idxA, idxB});
        dispatch({type: TYPES.REFRESH, refreshing: false});
        return Promise.resolve({idxA, idxB});
    };
}


